import React, { useMemo, useState } from 'react';
import { Modal } from 'react-bootstrap';

const campos = [
  ['Pasajero', 'cliNombres'],
  ['Fecha de emisión', 'fechaEmision'],
  ['Fecha de inicio de Vigencia', 'iniVigencia'],
  ['Fecha de fin de Vigencia', 'finVigencia'],
  ['Duración', 'duracion'],
  ['Destino', 'nomDestino'],
];

const ModalDeleteCertificado = ({ onClickEliminar, rowData }) => {
  const [show, setShow] = useState(false);

  const detail = useMemo(
    () =>
      campos.map(([label, field], index) => (
        <li key={index} style={{ fontSize: '17px' }}>
          {label}: {rowData?.[field]}
        </li>
      )),
    [rowData],
  );

  const onHide = () => {
    setShow(!show);
  };
  return (
    <React.Fragment>
      <button className="btn btn-sm btn-primary btn-block" onClick={onHide}>
        Eliminar
      </button>

      <Modal
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={onHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirmación</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <h4>Esta seguro de eliminar este Certificado?</h4>
          <ul>{detail}</ul>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              onClickEliminar(rowData);
              onHide();
            }}
          >
            Eliminar
          </button>
          <button className="btn btn-outline-primary" onClick={onHide}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default ModalDeleteCertificado;
